<template>
  <div v-if="pager.pages && pager.pages.length" class="bisylms-pagination m-1">
    <span class="next" :class="{'current': pager.currentPage === 1}" @click="setPage(1)" ><i class="fas fa-angle-double-left m-0"></i><!--{{labels.first}}--></span>
    <span class="next" :class="{'current': pager.currentPage === 1}" @click="setPage(pager.currentPage - 1)"><i class="fas fa-angle-left m-0"></i> <!--{{labels.previous}}--></span>
    <span v-for="page in pager.pages" :key="page" :class="{'current': pager.currentPage === page}" @click="setPage(page)">{{page}}</span>
    <span class="next" :class="{'current': pager.currentPage === pager.totalPages}" @click="setPage(pager.currentPage + 1)"><!--{{labels.next}}--><i class="fas fa-angle-right m-0"></i></span>
    <span class="next" :class="{'current': pager.currentPage === pager.totalPages}" @click="setPage(pager.totalPages)"><i class="fas fa-angle-double-right m-0"></i><!--{{labels.last}}--></span>
  </div>
</template>

<script>
import paginate from 'jw-paginate';

const defaultLabels = {
  first: 'First',
  last: 'Last',
  previous: 'Previous',
  next: 'Next'
};

const defaultStyles = {
  ul: {
    margin: 0,
    padding: 0,
    display: 'inline-block'
  },
  li: {
    listStyle: 'none',
    display: 'inline',
    textAlign: 'center'
  },
  a: {
    cursor: 'pointer',
    padding: '6px 12px',
    display: 'block',
    float: 'left'
  }
};

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    maxPages: {
      type: Number,
      default: 10
    },
    labels: {
      type: Object,
      default: () => defaultLabels
    },
    styles: {
      type: Object
    },
    disableDefaultStyles: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pager: {},
      ulStyles: {},
      liStyles: {},
      aStyles: {}
    }
  },
  created () {
    if (!this.$listeners.changePage) {
      throw 'Missing required event listener: "changePage"';
    }

    // set default styles unless disabled
    if (!this.disableDefaultStyles) {
      this.ulStyles = defaultStyles.ul;
      this.liStyles = defaultStyles.li;
      this.aStyles = defaultStyles.a;
    }

    // merge custom styles with default styles
    if (this.styles) {
      this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
      this.liStyles = { ...this.liStyles, ...this.styles.li };
      this.aStyles = { ...this.aStyles, ...this.styles.a };
    }

    // set page if items array isn't empty
    if (this.items && this.items.length) {
      this.setPage(this.initialPage);
    }
  },
  methods: {
    setPage(page) {
      const { items, pageSize, maxPages } = this;

      // get new pager object for specified page
      const pager = paginate(items.length, page, pageSize, maxPages);

      // get new page of items from items array
      const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

      // update pager
      this.pager = pager;

      // emit change page event to parent component
      this.$emit('changePage', pageOfItems);
    }
  }
}
</script>
